// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt3 {
    margin-top: 3px;
}

.mt10 {
    margin-top: 10px;
}

.mt15 {
    margin-top: 15px;
}

.mt20 {
    margin-top: 20px;
}

.mt30 {
    margin-top: 30px;
}

.mt20Percent {
    margin-top: 20%;
}

.-mb2Percent {
    margin-bottom: -2%;
}

.mb14Percent {
    margin-bottom: 1.4%;
}

.mb25Percent {
    margin-bottom: 2.5%;
}

.mb5 {
    margin-bottom: 5px !important;
}

.mb10 {
    margin-bottom: 10px;
}

.-mb10 {
    margin-bottom: -10px;
}

.mb20 {
    margin-bottom: 20px;
}

.-mr8 {
    margin-right: -8px;
}

.mr5 {
    margin-right: 5px;
}

.mr10 {
    margin-right: 10px;
}

.mr15 {
    margin-right: 15px;
}

.mr20 {
    margin-right: 20px;
}

.mr30 {
    margin-right: 30px;
}

.mr40 {
    margin-right: 40px;
}

.ml5 {
    margin-left: 5px;
}

.ml0 {
    margin-left: 10px;
}

.ml15 {
    margin-left: 15px;
}

.-ml5 {
    margin-left: -5px;
}

.-ml8 {
    margin-left: -8px;
}

.-ml15 {
    margin-left: -15px;
}

.-ml20 {
    margin-left: -20px;
}

.ml0 {
    margin-left: 0px !important;
}

.ml10 {
    margin-left: 10px !important;
}

.ml20 {
    margin-left: 20px;
}

.ml30 {
    margin-left: 30px;
}

.ml40 {
    margin-left: 40px;
}

.ml45 {
    margin-left: 45px;
}

.ml50 {
    margin-left: 50px;
}

.p10 {
    padding: 10px;
}

.p20 {
    padding: 20px;
}


.pr10 {
    padding-right: 10px !important;
}

.pl10 {
    padding-left: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/css/spacing.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".mt3 {\n    margin-top: 3px;\n}\n\n.mt10 {\n    margin-top: 10px;\n}\n\n.mt15 {\n    margin-top: 15px;\n}\n\n.mt20 {\n    margin-top: 20px;\n}\n\n.mt30 {\n    margin-top: 30px;\n}\n\n.mt20Percent {\n    margin-top: 20%;\n}\n\n.-mb2Percent {\n    margin-bottom: -2%;\n}\n\n.mb14Percent {\n    margin-bottom: 1.4%;\n}\n\n.mb25Percent {\n    margin-bottom: 2.5%;\n}\n\n.mb5 {\n    margin-bottom: 5px !important;\n}\n\n.mb10 {\n    margin-bottom: 10px;\n}\n\n.-mb10 {\n    margin-bottom: -10px;\n}\n\n.mb20 {\n    margin-bottom: 20px;\n}\n\n.-mr8 {\n    margin-right: -8px;\n}\n\n.mr5 {\n    margin-right: 5px;\n}\n\n.mr10 {\n    margin-right: 10px;\n}\n\n.mr15 {\n    margin-right: 15px;\n}\n\n.mr20 {\n    margin-right: 20px;\n}\n\n.mr30 {\n    margin-right: 30px;\n}\n\n.mr40 {\n    margin-right: 40px;\n}\n\n.ml5 {\n    margin-left: 5px;\n}\n\n.ml0 {\n    margin-left: 10px;\n}\n\n.ml15 {\n    margin-left: 15px;\n}\n\n.-ml5 {\n    margin-left: -5px;\n}\n\n.-ml8 {\n    margin-left: -8px;\n}\n\n.-ml15 {\n    margin-left: -15px;\n}\n\n.-ml20 {\n    margin-left: -20px;\n}\n\n.ml0 {\n    margin-left: 0px !important;\n}\n\n.ml10 {\n    margin-left: 10px !important;\n}\n\n.ml20 {\n    margin-left: 20px;\n}\n\n.ml30 {\n    margin-left: 30px;\n}\n\n.ml40 {\n    margin-left: 40px;\n}\n\n.ml45 {\n    margin-left: 45px;\n}\n\n.ml50 {\n    margin-left: 50px;\n}\n\n.p10 {\n    padding: 10px;\n}\n\n.p20 {\n    padding: 20px;\n}\n\n\n.pr10 {\n    padding-right: 10px !important;\n}\n\n.pl10 {\n    padding-left: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
